import {Component, Input, OnInit} from '@angular/core';
import {RequestHistory} from "../../../shared/models/request-history";

@Component({
  selector: 'app-request-history',
  templateUrl: './request-history.component.html',
  styleUrls: ['./request-history.component.css']
})
export class RequestHistoryComponent implements OnInit {

  @Input()
  requestHistories: RequestHistory[];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/modules/request/request-history/request-history.component.ts